/* tslint:disable */
/* eslint-disable */
/* @relayHash 183cd51f7bdbde44584cfc73f720b9e6 */

import { ConcreteRequest } from "relay-runtime";
export type FirmDesignProfileAddressMutationInput = {
    serviceId: string;
    line1?: string | null;
    line2?: string | null;
    city?: string | null;
    state?: string | null;
    zipCode?: string | null;
    country?: string | null;
    phoneNumber?: string | null;
    clientMutationId?: string | null;
};
export type profileAddressMutationVariables = {
    input: FirmDesignProfileAddressMutationInput;
};
export type profileAddressMutationResponse = {
    readonly firmDesignProfileAddressMutation: {
        readonly tradeFirm: {
            readonly publicProfile: {
                readonly address: {
                    readonly city: string | null;
                    readonly state: string | null;
                    readonly country: string | null;
                    readonly zipCode: string | null;
                } | null;
            } | null;
        } | null;
    } | null;
};
export type profileAddressMutation = {
    readonly response: profileAddressMutationResponse;
    readonly variables: profileAddressMutationVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "FirmDesignProfileAddressMutationInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "city",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "state",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "country",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "zipCode",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "profileAddressMutation",
    "type": "Mutations",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "firmDesignProfileAddressMutation",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "FirmDesignProfileAddressMutationPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tradeFirm",
            "storageKey": null,
            "args": null,
            "concreteType": "TradeFirmType",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "publicProfile",
                "storageKey": null,
                "args": null,
                "concreteType": "TradeFirmPublicProfileType",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "address",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Address",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "profileAddressMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "firmDesignProfileAddressMutation",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "FirmDesignProfileAddressMutationPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tradeFirm",
            "storageKey": null,
            "args": null,
            "concreteType": "TradeFirmType",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "publicProfile",
                "storageKey": null,
                "args": null,
                "concreteType": "TradeFirmPublicProfileType",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "address",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Address",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/)
                    ]
                  }
                ]
              },
              (v6/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "profileAddressMutation",
    "id": "app-buyer-trade/267.0.0-2020-06-02T16:23:38.038Z/profileAddressMutation",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '0421496af8a3ee12f78d2c70d256bb35';
export default node;
